import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import './wellbeing-scale-card.scss';

const WellbeingScaleCard = ({ cardInfo, selectedItem, selectItem }) => {
  const { t } = useTranslation();
  const { label, unselectedImage, selectedImage } = cardInfo;
  const isSelected = cardInfo.id === selectedItem.id;

  return (
    <li>
      <button
        type="button"
        className={`wellbeing-scale-card ${isSelected ? 'selected-card' : ''}`}
        onClick={() => selectItem(cardInfo)}
      >
        <div className={`wellbeing-scale-card__img ${isSelected ? 'selected-img' : ''} ${label}`}>
          <img
            src={isSelected ? selectedImage : unselectedImage}
            alt="emoji according to the text below"
            className={label}
          />
        </div>
        <div className={`wellbeing-scale-card__label ${isSelected ? 'selected-label' : ''} ${label}`}>
          <p>{t(`evieApp.feedback.wellbeingScale.options.${label}`)}</p>
        </div>
      </button>
    </li>
  );
};

WellbeingScaleCard.propTypes = {
  cardInfo: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.number,
    unselectedImage: PropTypes.string,
    selectedImage: PropTypes.string,
  }).isRequired,
  selectedItem: PropTypes.shape({ id: PropTypes.string }).isRequired,
  selectItem: PropTypes.func.isRequired,
};

export default WellbeingScaleCard;
